import { AlertSimple, Notificacion, NotificacionExtendida } from '@components/general/Alertas/Alertas';
import TitleDashboard from '@components/general/Titles/TitleDashboard'
import endpointsPaths from '@helpers/httpRequests/endpointsPaths/endpointsPaths';
import httpFormDataRequest from '@helpers/httpRequests/httpFormDataRequest';
import httpRequestsPaths from '@helpers/httpRequestsPaths/httpRequestsPaths';
import regExpStrings from '@helpers/regExpStrings/regExpStrings';
import React, { useEffect, useRef, useState } from 'react'
import { Alert, Button, Col, Container, Form, Row, Spinner } from 'react-bootstrap'
import { useTranslation } from 'react-i18next';
import { NotificationManager } from 'react-notifications';
import Swal from 'sweetalert2';

const NuevoRegistroMasivo = ({folioContrato, setRegistroMasivoCompletado, idGrupo, usuarioLogeado, colaboradores}) => {

    const {t} = useTranslation();

    const [showLoader, setShowLoader] = useState(false);


     const refInputFile = useRef(null);
        
        const [archivoValido, setArchivoValido] = useState(false);
    
        const [formValues, setFormValues] = useState({
        archivoAdjunto: '',
        })
        
    const gestionarAccesos = async (e) => {

        e.preventDefault();

        if (colaboradores.length === usuarioLogeado.cantidadEstudiantesGrupo) {
            NotificacionExtendida('error', 'Has alcanzado el límite de estudiantes a registrar en el foro de lectura');
            return;
        }

        const { archivoAdjunto } = formValues;
        try {
            setShowLoader(true);
            if (archivoAdjunto !== "") {
                // FETCH PARA MANDAR LOS DATOS DEL ARCHIVO AL SERVIDOR
                const formData = new FormData();

                formData.append("archivoAdjunto", archivoAdjunto);

                const { code, message: fetchMessage } = await httpFormDataRequest({
                    url: `${endpointsPaths.gruposLectura}/${httpRequestsPaths.gruposLectura.registroMasivoUsuarios}/${folioContrato}/${idGrupo}`,
                    body: formData,
                });

                if (code !== 200) {
                    Notificacion("error", fetchMessage);
                } else {
                    console.log("Archivo subido con exito.")

                    setFormValues({
                        ...formValues,
                        archivoAdjunto: '',
                    })

                    setShowLoader(false);
                    setRegistroMasivoCompletado(true);
                    // Notificacion("success", "Información importada con éxito");
                    await Swal.fire({
                        title: "Información importada con éxito",
                        text: "Se comienza a procesar la información, será notificado al correo electrónico registrado en su cuenta una vez que el proceso haya finalizado.",
                        icon: "success",
                        confirmButtonColor: "#3085d6",
                        confirmButtonText: t('ok'),
                    });

                }

            } else {
                setShowLoader(false);
                console.log("Algo ocurrio al enviar el archivo")
                Notificacion("error", "Sin información para importar");
            }
        }
        catch (error) {
            console.log("Error al importar las secciones");
            console.log(error);

        }
    }


    const handleOnChangeFile = (event) => {
        const { name, value } = event.target;
        // const reader = new FileReader();
        // reader.onload = function() {

        //     setBinaryData(reader.result);
        // };
        // reader.readAsArrayBuffer(event.target.files[0]);

        let file = event.target.files[0];

        if (regExpStrings.regexCaracteresUTF8(file.name)) {
            console.log("tiene utf-8");

            refInputFile.current.value = "";

            refInputFile.current.previousElementSibling.innerHTML =
                "Seleccionar archivo:";

            setArchivoValido(false);

            return NotificationManager.error("Nombre de archivo inválido");
        }

        setArchivoValido(true);

        setFormValues({
            ...formValues,
            [name]: file,
        });

        // const reader = new FileReader();
        // reader.readAsDataURL(file);
        // reader.onload = () => {
        //   setFileBase64(reader.result.split(",")[1]);
        // };
    };

    return (
        <Container fluid className="text-start">
            <Row className='justify-content-center'>
                <Col className="col-12">

                   <div className='text-center'>
                    <span style={{fontSize: '20px', color: 'red'}}>Importante: </span>
                     <span style={{ fontSize: "16px"}}>Antes de subir tu archivo de registro, es necesario que cumpla con el formato solicitado por el sistema para realizar correctamente el proceso de registro</span>
                     <p className='mt-3' style={{fontWeight: 'bold'}}>Puedes descargar <a className="pointer" href="https://globalclickmexico.com/lectura-inteligente/RegistroForoLectura.xlsx" download>aquí</a> la plantilla para formatear la información correctamente.</p>
                   </div>

                    <Form className='mt-4' onSubmit={gestionarAccesos}>
                        <Form.Group>
                            <Form.Label>Adjuntar archivo</Form.Label>

                            {/* //* VALIDAR DEL LADO DEL SERVIDOR QUE LOS ARCHIVOS SEAN DE PAQUETERIA OFFICE O PDF */}
                            <Form.Control
                                ref={refInputFile}
                                required
                                onChange={handleOnChangeFile}
                                name="archivoAdjunto"
                                accept=".xls,.xlsx"
                                type="file"
                            />

                            {/* {validacionForm.archivoAdjunto && <p className="text-danger mt-3">Es necesario adjuntar un archivo a la publicación</p>} */}

                            <Alert
                                variant="warning"
                                className={`mt-3 ${!archivoValido ? "" : "d-none"}`}
                            >
                                Asegúrate que el nombre de tu archivo no contenga tildes ni
                                caracteres especiales
                            </Alert>

                            <Form.Control.Feedback type="invalid">
                                <p>Este campo es obligatorio</p>
                            </Form.Control.Feedback>
                        </Form.Group>

                        <div className='gap-2 d-grid mt-3'>
                            <Button type="submit" className='btn btn-primary'>{showLoader ? "Registrando..." : "Registrar"}</Button>
                        </div>
                        {
                            showLoader && (
                                <div className='text-center mt-4'>
                                    <p className='text-center text-warning'>Por favor espera mientras termina el proceso de registro...</p>
                                    <Spinner animation="border" className='mt-2' size="lg" variant="warning" />
                                </div>
                            )
                        }

                    </Form></Col>
            </Row>
        </Container>
    );
};

export default NuevoRegistroMasivo;
